module.exports = __webpack_public_path__ + "static/media/tracable-products.9d415902.svg";